import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle, AlertTriangle, XOctagon } from 'lucide-react';

const icons = {
  success: CheckCircle,
  warning: AlertTriangle,
  error: XOctagon,
};

const colors = {
  success: 'bg-success',
  warning: 'bg-warning',
  error: 'bg-danger',
};

const Notification = ({ id, message, type, onClose }) => {
  const [progress, setProgress] = useState(100);
  const Icon = icons[type] || icons.info; // Ajout d'une valeur par défaut

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress <= 0) {
          clearInterval(timer);
          onClose(id);
          return 0;
        }
        return oldProgress - 2;
      });
    }, 100);

    return () => clearInterval(timer);
  }, [id, onClose]);

  return (
    <motion.div
      initial={{ opacity: 0, y: -50, x: 50 }}
      animate={{ opacity: 1, y: 0, x: 0 }}
      exit={{ opacity: 0, y: -50, x: 50 }}
      className={`fixed top-4 right-4 p-4 rounded-md shadow-md flex items-center justify-between ${colors[type] || colors.info} text-ink z-[9999]`}
      style={{ zIndex: 99999 }}
    >
      <div className="flex items-center">
        <Icon size={18} className="mr-2" />
        <span>{message}</span>
      </div>
      <button onClick={() => onClose(id)} className="ml-4 text-ink hover:text-ink">
        <X size={18} />
      </button>
      <div className="absolute bottom-0 left-0 h-1 bg-white" style={{ width: `${progress}%` }} />
    </motion.div>
  );
};

export default Notification;